import React, { useState } from 'react';
import { store } from 'react-notifications-component';
import { BodyM, TaglineP } from '../../../styles/stylesTypography';
import { theme } from '../../../styles/theme';
import TextOrStatus from '../../textOrStatus';
import TableWithLabelBlackV2 from '../../TableWithLabelBlack/indexV2';
import IconOrder from '../../../assets/icons/icon-order.png';
import IconAtencao from '../../../assets/icons/icon-status-nao-enviado.png';
import { setReceitaSolicitada } from '../../../services/receitaSolicitada';
import { isOmie } from '../../../services/globalFunctions';
import Modal from '../../modal/modalGeneric';
import ModalYesNo from '../../modal/modalYesNo';
import EditProdutor from '../../../pages/produtores/edit';
import EditFazenda from '../../../pages/produtores/editLocal';
import ModalVincularFazenda from '../cardSolicitacao/ModalVincularFazenda';
import api from '../../../services/api';
import identifyErrorMenssage from '../../../services/identifyErrorMenssage';

import * as S from './styles'

const PRODUTOR_CAMPOS_OBRIGATORIOS = ['nome', 'cpf_cnpj', 'telefone', 'cep', 'logradouro', 'numero', 'bairro', 'cidade'];
const FAZENDA_CAMPOS_OBRIGATORIOS = ['nome', 'cpf_cnpj', 'cep', 'endereco', 'numero', 'bairro', 'cidade', 'estado', 'cod_ibge'];

const isProdutorIncompleto = (produtor) =>
  !produtor || PRODUTOR_CAMPOS_OBRIGATORIOS.some((campo) => !produtor[campo]);

// Fazenda AUSENTE (agro_farm_id null) não conta como "incompleta" pra fins do ícone de
// atenção - a escolha/criação de fazenda já acontece naturalmente na tela de emissão
// (PrescriptionStepTwo já suporta "Adicionar Novo" e seleção entre fazendas do produtor).
// Só fazenda que EXISTE mas com campo faltando é que bloqueia aqui.
const isFazendaIncompleta = (fazenda) =>
  !!fazenda && FAZENDA_CAMPOS_OBRIGATORIOS.some((campo) => !fazenda[campo]);

// produto_apto_estado é calculado 1x na criação do rascunho (ver criarRascunho no
// omie.service.ts) - aqui só lê o flag já pronto, sem chamar compêndio de novo.
const produtosIncompativeisComEstado = (item) =>
  (item?.agro_prescriptions_relations_orders || []).filter(
    (produto) => produto?.produto_apto_estado === false,
  );

const isProdutoIncompativelComEstado = (item) =>
  produtosIncompativeisComEstado(item).length > 0;

// Pedido veio da Omie sem CNPJ de entrega - rascunho criado sem fazenda vinculada (mesmo
// critério do card, ver isFazendaAusente em cardSolicitacao/helpers.js).
const isFazendaAusente = (item) =>
  isOmie() && item?.status === 1 && !item?.local_aplicacao_nome;

const TableSolicitacoes = ({ items = [], isLoading = false, onDataChanged }) => {
  const [loadingItemId, setLoadingItemId] = useState(null);
  const [validandoItem, setValidandoItem] = useState(null);
  const [showModalProdutor, setShowModalProdutor] = useState(false);
  const [showModalFazenda, setShowModalFazenda] = useState(false);
  const [showModalCancelarProduto, setShowModalCancelarProduto] = useState(false);
  const [showModalVincularFazenda, setShowModalVincularFazenda] = useState(false);

  const cancelarSolicitacaoAgroReceita = async (resposta) => {
    if (resposta === 1 && validandoItem?.id) {
      try {
        await api.put(`/rascunhos/${validandoItem.id}/cancelar`);
        store.addNotification({
          title: 'Sucesso!',
          message: 'Solicitação cancelada no AgroReceita.',
          type: 'success',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animated', 'fadeIn'],
          animationOut: ['animated', 'fadeOut'],
          dismiss: { duration: 4000, onScreen: true }
        });
        onDataChanged?.();
      } catch (err) {
        store.addNotification({
          title: 'Erro!',
          message: identifyErrorMenssage(err),
          type: 'danger',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animated', 'fadeIn'],
          animationOut: ['animated', 'fadeOut'],
          dismiss: { duration: 4000, onScreen: true }
        });
      }
    }
    setShowModalCancelarProduto(false);
  };
  const formatQuantidade = (data) => {
    const src = (data && typeof data === 'object' && 'quantidade_adquirir' in data && 'unidade_quantidade_adquirir' in data)
      ? data
      : (Array.isArray(data?.agro_prescriptions_relations_orders) ? data.agro_prescriptions_relations_orders[0] : null);
    if (!src) return "";
    const q = src.quantidade_adquirir;
    const u = src.unidade_quantidade_adquirir;
    if (q == null || u == null) return "";
    const formatted = String(q).replace(".", ",");
    return `${formatted} ${u}`;
  };

  const formatarData = (dataISO) => {
    const mesesAbreviados = [
      'JAN','FEV','MAR','ABR','MAI','JUN','JUL','AGO','SET','OUT','NOV','DEZ'
    ];
    if (!dataISO) return '-';
    const data = new Date(dataISO);
    const dia = data.getUTCDate();
    const mes = mesesAbreviados[data.getUTCMonth()];
    const ano = data.getUTCFullYear();
    return `${dia} ${mes} ${ano}`;
  };

  const formatLocal = (item) => {
    const uf = item?.local_aplicacao_estado || '-';
    const local = item?.local_aplicacao_nome || '-';
    return `${uf}: ${local}`;
  };

  const waitForNextPaint = () => new Promise((resolve) => {
    if (typeof window === 'undefined' || typeof window.requestAnimationFrame !== 'function') {
      setTimeout(resolve, 0);
      return;
    }
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(resolve);
    });
  });

  const handleSavedRecipe = async (item) => {
    try {
      console.log('[tableSolicitacao] clicou solicitacao - item:', item, 'item.id:', item?.id);
      const saved = setReceitaSolicitada(item);
      console.log('[tableSolicitacao] setReceitaSolicitada salvou?', saved);
      localStorage.setItem('ReceitaSolicitadaReload', true);
      return saved;
    } catch (e) {
      console.error('[tableSolicitacao] erro ao salvar solicitacao:', e);
      return false;
    }
  };

  const hasCultura = items.some(i => i.cultura_nome_comum);

  const columns = [
    {
      key: 'data_solicitacao',
      label: 'Data solicitação',
      minWidth: '110px',
      width: '100%',
      maxWidth: '140px',
      render: (item) => (
        <TaglineP
          color={item.status === 3 || item.status === 4 ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2}
          fontWeight={600}
        >
          {formatarData(item.data_emissao)}
        </TaglineP>
      )
    },
    {
      key: 'status',
      label: 'Status',
      minWidth: '172px',
      width: '194px',
      render: (item) => (
        <TextOrStatus
          maxWidth="auto"
          type="status"
          status={item.status}
          textDefault="Em aberto"
          textSuccess="Receita Gerada"
          textError="Receita cancelada"
          textSolicitacaoCancelada="Solicitação cancelada"
          textWaiting="Aguardando liberação"
        />
      )
    },
    {
      key: 'produto',
      label: 'Produto',
      minWidth: '260px',
      width: '100%',
      maxWidth: '320px',
      enableHorizontalScroll: true,
      render: (item) => (
        item.agro_prescriptions_relations_orders?.length > 1 ? (
          <S.ContainerProdutor>
            {item.agro_prescriptions_relations_orders.map((order, idx) => (
              <BodyM
                key={`${item.id || 'item'}-produto-${idx}`}
                color={item.status === 3 || item.status === 4 ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2}
                fontWeight={800}
              >
                {order.nome_comercial}
              </BodyM>
            ))}
          </S.ContainerProdutor>
        ) : (
          <BodyM
            color={item.status === 3 || item.status === 4 ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2}
            fontWeight={800}
          >
            {item.nome_comercial}
          </BodyM>
        )
      )
    },
    {
      key: 'qtd',
      label: 'Qtd',
      minWidth: '75px',
      width: '120px',
      enableHorizontalScroll: true,
      render: (item) => (
        item.agro_prescriptions_relations_orders?.length >= 2 ? (
          <div style={{ width: "75px", gap: "8px", display: "flex", flexDirection: "column" }}>
            {item.agro_prescriptions_relations_orders.map((order, idx) => (
              <TextOrStatus
                key={`${item.id || 'item'}-qtd-${idx}`}
                minWidth="65px"
                type="text"
                status="default"
                textDefault={formatQuantidade(order)}
                align="center"
                color={theme.colors.gray.Cinza_2}
                backgroundColor={theme.colors.gray.Cinza_11}
                disabled={item.status === 3 || item.status === 4}
              />
            ))}
          </div>
        ) : (
          item.agro_prescriptions_relations_orders?.length === 1 ? (
            <TextOrStatus
              minWidth="65px"
              type="text"
              status="default"
              textDefault={formatQuantidade(item)}
              align="center"
              color={theme.colors.gray.Cinza_2}
              backgroundColor={theme.colors.gray.Cinza_11}
              disabled={item.status === 3 || item.status === 4}
            />
          ) : <div style={{ minWidth: "65px", height: "25px" }} />
        )
      )
    },
    {
      key: 'pedido',
      label: '# Pedido',
      minWidth: '140px',
      width: '100%',
      maxWidth: '160px',
      enableHorizontalScroll: true,
      render: (item) => (
        <TaglineP
          color={item.status === 3 || item.status === 4 ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2}
          fontWeight={600}
        >
          Pedido: <b>{item.id_pedido}</b>
        </TaglineP>
      )
    },
    ...(isOmie() ? [] : [{
      key: 'tecnico',
      label: 'Técnico',
      minWidth: '120px',
      width: '145px',
      enableHorizontalScroll: true,
      render: (item) => (
        <TextOrStatus
          maxWidth="auto"
          type="text"
          status="default"
          imageSrcType="agronomo"
          textDefault={item.agronomo_nome}
          color={theme.colors.gray.Cinza_2}
          backgroundColor={theme.colors.gray.Cinza_11}
          disabled={item.status === 3 || item.status === 4}
        />
      )
    }]),
    {
      key: 'produtor',
      label: 'Produtor',
      minWidth: '120px',
      width: '310px',
      enableHorizontalScroll: true,
      render: (item) => (
        <TextOrStatus
          maxWidth="auto"
          type="text"
          status="default"
          noEllipsis={true}
          textDefault={item.produtor_nome}
          color={theme.colors.white.Branco}
          backgroundColor={theme.colors.blue.Azul_link}
          disabled={item.status === 3 || item.status === 4}
        />
      )
    },
    {
      key: 'local',
      label: 'Local de aplicação',
      minWidth: '160px',
      width: '310px',
      enableHorizontalScroll: true,
      render: (item) => (
        <TextOrStatus
          maxWidth="auto"
          type="text"
          imageSrcType="local"
          status="default"
          noEllipsis={true}
          textDefault={formatLocal(item)}
          color={theme.colors.blue.Azul_link}
          backgroundColor={theme.colors.gray.Cinza_12}
          disabled={item.status === 3 || item.status === 4}
        />
      )
    },
    ...(hasCultura && !isOmie() ? [{
      key: 'cultura',
      label: 'Cultura',
      minWidth: '120px',
      width: '100%',
      maxWidth: '140px',
      enableHorizontalScroll: true,
      render: (item) => (
        <TextOrStatus
          maxWidth="120px"
          type="text"
          status="default"
          textDefault={item.cultura_nome_comum}
          color={theme.colors.white.Branco}
          backgroundColor={theme.colors.gray.Cinza_2}
          disabled={item.status === 3 || item.status === 4}
        />
      )
    }] : []),
    ...(isOmie() ? [] : [{
      key: 'filial',
      label: 'Filial',
      minWidth: '230px',
      width: "100%",
      maxWidthContent: "100%",
      enableHorizontalScroll: true,
      render: (item) => (
        <TaglineP
          color={item.status === 3 || item.status === 4 ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2}
          fontWeight={600}
        >
          Filial {item.agro_subsidiaries?.nome_fantasia || '-'}
        </TaglineP>
      )
    }])
  ];

  return (
    <>
      <TableWithLabelBlackV2
        columns={columns}
        data={items}
        getRowId={(item, idx) => item.id || idx}
        actionsColumn={{
          enabled: true,
          position: 'first',
          label: 'AÇÕES',
          width: '100%',
          minWidth: '90px',
          maxWidth: '110px',
          justifyContent: 'flex-start',
          buttons: [
            {
              key: 'validar-cadastro',
              icon: IconAtencao,
              iconAlt: 'Ícone de atenção',
              tooltip: 'Faltam dados obrigatórios do produtor/fazenda - clique para completar',
              isVisible: (item) =>
                isOmie() &&
                item?.status === 1 &&
                (isProdutorIncompleto(item?.agro_producers) || isFazendaIncompleta(item?.agro_farms)),
              onClick: (item) => {
                setValidandoItem(item);
                if (isProdutorIncompleto(item?.agro_producers)) {
                  setShowModalProdutor(true);
                } else {
                  setShowModalFazenda(true);
                }
              }
            },
            {
              key: 'produto-incompativel-estado',
              icon: IconAtencao,
              iconAlt: 'Ícone de atenção',
              tooltip: 'Produto não homologado para o estado da fazenda - clique para ver detalhes',
              isVisible: (item) =>
                isOmie() && item?.status === 1 && isProdutoIncompativelComEstado(item),
              onClick: (item) => {
                setValidandoItem(item);
                setShowModalCancelarProduto(true);
              }
            },
            {
              key: 'validar-fazenda-ausente',
              icon: IconAtencao,
              iconAlt: 'Ícone de atenção',
              tooltip: 'Pedido sem fazenda vinculada - clique para selecionar uma',
              isVisible: (item) =>
                isFazendaAusente(item) &&
                !isProdutorIncompleto(item?.agro_producers) &&
                !isFazendaIncompleta(item?.agro_farms) &&
                !isProdutoIncompativelComEstado(item),
              onClick: (item) => {
                setValidandoItem(item);
                setShowModalVincularFazenda(true);
              }
            },
            {
              key: 'request-recipe',
              icon: IconOrder,
              iconAlt: 'Ícone de pedido',
              tooltip: (item) => {
                if (item?.status !== 1) return 'Ação indisponível';
                if (isOmie() && (isProdutorIncompleto(item?.agro_producers) || isFazendaIncompleta(item?.agro_farms))) {
                  return 'Complete o cadastro do produtor/fazenda antes de emitir';
                }
                if (isOmie() && isProdutoIncompativelComEstado(item)) {
                  return 'Produto não homologado para o estado da fazenda';
                }
                if (isFazendaAusente(item)) {
                  return 'Pedido sem fazenda vinculada - selecione uma antes de emitir';
                }
                return 'EMITIR RECEITA';
              },
              isDisabled: (item) =>
                item?.status !== 1 ||
                (isOmie() && (isProdutorIncompleto(item?.agro_producers) || isFazendaIncompleta(item?.agro_farms))) ||
                (isOmie() && isProdutoIncompativelComEstado(item)) ||
                isFazendaAusente(item),
              isLoading: (item) => loadingItemId === item?.id,
              loadingSize: '14px',
              onClick: async (item) => {
                const itemId = item?.id ?? null;
                setLoadingItemId(itemId);
                let redirected = false;
                try {
                  const canRedirect = await handleSavedRecipe(item);
                  if (!canRedirect) return;
                  await waitForNextPaint();
                  redirected = true;
                  window.location.href = isOmie() ? '/receitas/addlote' : '/receitas/add';
                } finally {
                  if (!redirected) {
                    setLoadingItemId(null);
                  }
                }
              }
            }
          ]
        }}
        isLoading={isLoading}
        getRowStyle={(item) => (item.status === 3 || item.status === 4 ? { backgroundColor: theme.colors.disabled.Fundo_Desabilitado } : undefined)}
      />

      {showModalProdutor && validandoItem?.agro_producers?.id && (
        <Modal
          size='lg'
          show={showModalProdutor}
          onHide={() => setShowModalProdutor(false)}
        >
          <EditProdutor
            idProdutor={validandoItem.agro_producers.id}
            isModal={true}
            lockFilledFields={true}
            update={() => {
              setShowModalProdutor(false);
              onDataChanged?.();
              if (isFazendaIncompleta(validandoItem?.agro_farms)) {
                setShowModalFazenda(true);
              }
            }}
            openModal={(e) => setShowModalProdutor(e)}
          />
        </Modal>
      )}

      {showModalFazenda && validandoItem?.agro_farms?.id && validandoItem?.agro_producers?.id && (
        <Modal
          size='lg'
          show={showModalFazenda}
          onHide={() => setShowModalFazenda(false)}
        >
          <EditFazenda
            idFazenda={validandoItem.agro_farms.id}
            idProdutor={validandoItem.agro_producers.id}
            isModal={true}
            openModal={(e) => {
              setShowModalFazenda(e);
              if (!e) onDataChanged?.();
            }}
          />
        </Modal>
      )}

      <ModalYesNo
        show={showModalCancelarProduto}
        onHide={() => setShowModalCancelarProduto(false)}
        resposta=''
        update={(e) => cancelarSolicitacaoAgroReceita(e)}
        title='Produto não homologado para o estado!'
        text={`${(() => {
          const listaProdutos = produtosIncompativeisComEstado(validandoItem)
            .map((p) => p?.nome_comercial)
            .filter(Boolean);
          const nomes = listaProdutos.join(', ');
          const plural = listaProdutos.length > 1;
          return `${nomes || 'Um ou mais produtos'} não ${plural ? 'estão homologados' : 'está homologado'} para o estado da fazenda (${validandoItem?.local_aplicacao_estado || validandoItem?.agro_farms?.estado || '-'}). Esse pedido precisa ser cancelado e refeito na Omie com o produto correto - editar o pedido existente não atualiza esta solicitação. Deseja cancelar esta solicitação no AgroReceita agora? (isso não cancela o pedido na Omie)`;
        })()}`}
        btnNo={true}
      />

      {showModalVincularFazenda && validandoItem?.id && validandoItem?.agro_producers?.id && (
        <Modal
          size='lg'
          show={showModalVincularFazenda}
          onHide={() => setShowModalVincularFazenda(false)}
        >
          <ModalVincularFazenda
            orderId={validandoItem.id}
            produtorId={validandoItem.agro_producers.id}
            onClose={() => setShowModalVincularFazenda(false)}
            onVinculado={() => {
              setShowModalVincularFazenda(false);
              onDataChanged?.();
            }}
          />
        </Modal>
      )}
    </>
  );
};

export default TableSolicitacoes;
